import { render, staticRenderFns } from "./result-suggestion.vue?vue&type=template&id=444cf4e4&"
import script from "./result-suggestion.vue?vue&type=script&lang=ts&"
export * from "./result-suggestion.vue?vue&type=script&lang=ts&"
import style0 from "./suggestion.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports